import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Map from './FacilityMap';
import { CAccordion, CFormSwitch, CModalFooter, CCard, CCardBody, CAccordionItem, CAccordionHeader, CAccordionBody, CCardFooter, CFormSelect, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem, CFormCheck } from '@coreui/react';
import FetchFacilityDetails from '../../services/general/getFacilityDetails.api';
import FacilityCRUD from "../../services/general/getFacilityData.api.js";
import FacilityTypeFn from "../../services/general/modifyFacilityType.api";
import AutoComplete from './AutoComplete';
import FacilityForm from "./FacilityForm";
import { Form } from "@formio/react";
import fetchPatientData from "../../services/general/patientGeneralAPI.api.js";
import { Filter, Download,Copy } from 'lucide-react'
import Select from 'react-select';
import toast from 'react-hot-toast';
import { toastConfig } from '../../constants/other.config';
import { CButton, CRow, CCol, CModal, CModalBody, CModalHeader, CModalTitle, CFormLabel, CFormInput, CFormTextarea } from '@coreui/react';import providerCredentialingCRUD from '../../services/general/ProviderCredentialingCRUD.api.js';
import { buildCredentialingTemplate } from './kanban-components/credentialingutility';import SchedulerFacilityMap from './SchedulerFacilityMap';
const selectDarkThemeStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: 'var(--ui-dashboard-surface-2, #1b1b1b)',
    borderColor: state.isFocused ? 'var(--ui-dashboard-border-strong, #3a3a3a)' : 'var(--ui-dashboard-border-strong, #3a3a3a)',
    borderRadius: '6px',
    boxShadow: 'none',
    '&:hover': {
      borderColor: 'var(--ui-dashboard-border-strong, #3a3a3a)',
    },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: 'var(--ui-dashboard-surface, #161616)',
    borderRadius: '6px',
    border: '1px solid var(--ui-dashboard-border-strong, #3a3a3a)',
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? 'var(--ui-color-primary, #1a76d3)'
      : state.isFocused
      ? 'var(--ui-dashboard-surface-2, #1b1b1b)'
      : 'transparent',
    color: 'var(--ui-text-primary, #ffffff)',
    '&:active': {
      backgroundColor: 'var(--ui-color-primary, #1a76d3)',
    }
  }),
  singleValue: (base) => ({
    ...base,
    color: 'var(--ui-text-primary, #ffffff)',
  }),
};

const AddFacility = ({ scheduledPatient = [], selectedProviderData, selectedProvider: selectedProviderProp }) => {
  const location = useLocation();
  const queryProviderName = decodeURIComponent(new URLSearchParams(location.search).get('provider') || '');
 
  const newFacility = useRef([]);
  const [searchValue, setSearchValue] = useState('');
  const [visible, setVisible] = useState(false);
  const [schema, setSchema] = useState({ components: [] });
  const [formAnswer, setFormAnswer] = useState({ components: [] });
  const [facilities, setFacilities] = useState([]);
    const allFacilities = useRef([]);
  const [facilityType, setFacilityType] = useState([]);
  const [providerList, setProviderList] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const rowData = useRef({});
  const [selectedProvider, setSelectedProvider] = useState([]);
  const [selectedProviderID, setSelectedProviderID] = useState(-1);
  const [selectedProviderName, setSelectedProviderName] = useState('');
  const [radius, setRadius] = useState(6);
  const [selectedProviderFacilities, setSelectedProviderFacilities] = useState([])
  const [options, setOptions] = useState([]);
  const [selectedCounty, setSelectedCounty] = useState('');
  const [countyList, setCountyList] = useState([]);
  const [selectedFacility, setSelectedFacilities] = useState([]);
  const [facilityCounter, setFacilityCounter] = useState(0);
  const [latlang, setLatlang] = useState(null);
  const [typeName, setTypeName] = useState(null);
  const [practicing, setPracticing] = useState(null);
  const [isToggled, setIsToggled] = useState(false);
  const [providerSelectedFacility, setProviderSelectedFacility] = useState([]);
  const [providerFullDetails, setProviderFullDetails] = useState(null)
  const [showDropdown, setShowDropdown] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [scheduleAppointmentPatinet, setScheduledPatient] = useState([]);
const [searchTerm, setSearchTerm] = useState("");
  const toggleDropdown = () => {
    setIsDropdownOpen(prevState => !prevState);
  };
  const handleSubmitAndClose = async () => {
    if (providerSelectedFacility.length === 0) {
      toast.error('Please select at least one facility for credentialing', toastConfig)
      return
    }

    const Details = providerFullDetails?.Details
    if (!Details) {
      toast.error('Please select a provider', toastConfig)
      return
    }

    await handleSubmit()

    for (const facilityId of providerSelectedFacility) {
      const facility = facilities.find((f) => String(f.ID) === String(facilityId))
      if (!facility) continue

      const credentialTemplate = buildCredentialingTemplate({
        FacilityName: facility.Name,
        FacilityID: facility.ID,
        ProviderID: Details.ID,
        ProviderName: Details.Name,
        Description: facility.Type,
      })

      const taskPayload = {
        Title: facility.Name,
        Description: facility.Type,
        TaskType: 'Credentialing',
        FacilityID: facility.ID,
        FacilityName: facility.Name,
        ProviderID: Details.ID,
        ProviderName: Details.Name,
        Status: 'Pending',
        Priority: 'Medium',
        subtask: credentialTemplate.subtasks || [],
        SubtasksJson: credentialTemplate.subtasks || [],
      }

      const response = await providerCredentialingCRUD(JSON.stringify(taskPayload), '', 'INSERT')
      const parsed = typeof response?.d === 'string' ? JSON.parse(response.d) : response
      if (!parsed?.success) {
        toast.error(parsed?.message || `Failed to create task for ${facility.Name}`)
        return
      }
    }

    toast.success('Credentialing tasks created successfully', toastConfig)
    setProviderSelectedFacility([])
    setIsDropdownOpen(false)

    window.open(
      `/home/credentialing?providerId=provider-${Details.ID}`,
      '_blank',
      'noopener,noreferrer',
    )
  };

  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  console.log("allFacilities", allFacilities.current);

  const getFacilityType = async () => {
    let a = await FacilityTypeFn("SELECT", "", "");
    let data = a.d;
    data = JSON.parse(data);
    setOptions(data.Data.map(obj => obj.Name));
  };

  const AddFacilityFn = async (newFacility) => {
    rowData.current = newFacility;
    await getFacilityType();
    setModalVisible(true);
  };

  const fetchFacility = async () => {
    newFacility.current = [];
    let temp2 = await FacilityCRUD("SELECTALL", {});
    let temp2FacilityList = JSON.parse(temp2.d);
    temp2FacilityList = temp2FacilityList.Data.filter(obj => {
      if (obj.Lat) {
        return obj;
      }
    }) 
    //   if(scheduledPatient.length > 0) {
     
    //     temp2FacilityList = temp2FacilityList.filter(obj => {
    //       return scheduledPatient.some(scheduled => scheduled.current.Facility.value === obj.ID);
    //     });
    //   }
    let temp3 = await FacilityTypeFn("SELECT");
    let types = JSON.parse(temp3.d);
    types = types.Data;
    const facilitiesWithShape = temp2FacilityList.map((facility) => {
      try {
        let otherDetails = JSON.parse(facility["OtherDetails"]);

        if (otherDetails && Object.keys(otherDetails).length > 0) {
          if (otherDetails["SisterCompany"] !== "") {
            facility["Sister"] = true;
            facility["SisterCompany"] = otherDetails["SisterCompany"];
          } else {
            facility["Sister"] = false;
            facility["SisterCompany"] = "";
          }
        } else {
          facility["Sister"] = false;
          facility["SisterCompany"] = "";
        }
      } catch (e) {
        facility["Sister"] = false;
        facility["SisterCompany"] = "";
      }

      const typeObj = types.find((type) => type.Name === facility.Type);
      if (typeObj) {
        return { ...facility, Marker: typeObj.Marker };
      }
      return facility;
    });


       
    //   if (scheduledPatient.length > 0) {

    //      const facilitiesWithShapeData = facilitiesWithShape.filter(obj => {
    //           return scheduledPatient.some(scheduled => scheduled.current.Facility.value === obj.ID);
    //       });
    //       setFacilities(facilitiesWithShapeData);
    //       setFacilityCounter(facilitiesWithShapeData.length)
    //   }else{
    //       setFacilities(facilitiesWithShape);
    //       setFacilityCounter(facilitiesWithShape.length)
    //   }
      allFacilities.current = facilitiesWithShape;
      setFacilities(facilitiesWithShape);
      setFacilityCounter(facilitiesWithShape.length)

 

    //   if (scheduledPatient.length > 0 && allFacilities.current.length > 0) {
    //       console.log("allFacilities", allFacilities.current);
    //       const filtered = allFacilities.current.filter(fac =>
    //           scheduledPatient.some(sch => sch.current.Facility.value === fac.ID)
    //       );
    //       allFacilities.current = filtered;
    //       setFacilities(filtered);
    //   } else {
    //     allFacilities.current = facilitiesWithShape;
    //     setFacilities(allFacilities.current);
    //   }
      
    setFacilityType(types);

    const uniqueCounties = [...new Set(temp2FacilityList.map(facility => facility.County))];
    setCountyList(uniqueCounties);

    let providerDetails = await fetchPatientData("SELECT", "Provider", "{}");
    providerDetails = JSON.parse(providerDetails?.d);

      if(scheduledPatient.length > 0) {
       const  providerDetailsData = providerDetails.Data.filter(obj => {
          return scheduledPatient.some(scheduled => scheduled.current.Provider.value === obj.ID);
        });

        setScheduledPatient( providerDetailsData);
       }
      
    setProviderList(providerDetails?.Data);
  };

    // useEffect(() => {
    //     if (scheduledPatient.length > 0 && allFacilities.current.length > 0) {
    //         console.log("allFacilities", allFacilities.current);
    //         const filtered = allFacilities.current.filter(fac =>
    //             scheduledPatient.some(sch => sch.current.Facility.value === fac.ID)
    //         );
    //         setFacilities(filtered);
    //     } else {
    //         console.log("allFacilities====>else", allFacilities.current);
    //         //   setFacilities(allFacilities.current);
    //     }
    // }, [allFacilities.current]);

  useEffect(() => {
    if (scheduledPatient.length > 0 && allFacilities.current.length > 0) {
      const scheduledFiltered = allFacilities.current.filter(fac =>
        scheduledPatient.some(sch => sch.current.Facility.value === fac.ID)
      );
 
  
      const providerFacilityIDs = selectedProviderData?.Facilities?.map(f => parseInt(f.FacilityID)) || [];

      const providerFiltered = allFacilities.current.filter(fac =>
        providerFacilityIDs.includes(fac.ID)
      );
 
      const combined = [...scheduledFiltered, ...providerFiltered];
      const uniqueFacilities = combined.filter(
        (fac, index, self) => index === self.findIndex(f => f.ID === fac.ID)
      );

      setFacilities(uniqueFacilities);
    } else {
      console.log("allFacilities====>else", allFacilities.current);
 
    }
  }, [scheduledPatient, allFacilities.current]);


    console.log("facilities", facilities);
  function haversineDistance(lat1, lng1, lat2, lng2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLng = (lng2 - lng1) * (Math.PI / 180);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  const onFilter = (type, n, ID = '', filName = '', userTriggered = false) => {
    setTypeName(filName)
    let newFacilities = [];
    if (type === 'type') {
      if (n === 'all' || n === 'Mixed') {
        newFacilities = allFacilities.current
      } else if (n === 'radius') {
        const providerToUse = providerList.find(item => item.ID === ID) || selectedProvider[0] || null
        const targetLat = parseFloat(providerToUse?.Lat)
        const targetLng = parseFloat(providerToUse?.Lng)

        const facilitySource = facilities && facilities.length > 0 ? facilities : allFacilities.current
        let radiusFiltered = []

        if (providerToUse?.Lat && providerToUse?.Lng) {
          radiusFiltered = facilitySource.filter(facility => {
            const facilityLat = parseFloat(facility.Lat)
            const facilityLng = parseFloat(facility.Lng)
            const distance = haversineDistance(targetLat, targetLng, facilityLat, facilityLng)
            return distance <= Math.round(radius * 1609.34) / 1000
          })
        }

        if (isToggled) {
          const providerFacilityIds = selectedProviderFacilities.map(facility => String(facility.FacilityID))
          newFacilities = radiusFiltered.filter(facility => providerFacilityIds.includes(String(facility.ID)))
        } else {
          newFacilities = allFacilities.current
        }

        if (filName !== '') {
          newFacilities = newFacilities.filter(obj => obj.Type === filName)
        }
      } else {
        newFacilities = allFacilities.current.filter(obj => obj.Type === n)
      }
    } else if (type === 'status') {
      if (selectedProvider.length > 0) {
        if (n === 'all') {
          newFacilities = allFacilities.current
        } else if (n === 'Credentialed' || n === 'Credentialing (In Progress)') {
          const credentialFilter = n === 'Credentialed' ? 'Yes' : 'In Progress'
          const filteredProviderFacilities = selectedProviderFacilities.filter(obj =>
            String(obj.Credentialed).trim().toLowerCase() === credentialFilter.trim().toLowerCase(),
          )

          const facilityIdSet = new Set(filteredProviderFacilities.map(f => String(f.FacilityID)))
          newFacilities = allFacilities.current.filter(facility => facilityIdSet.has(String(facility.ID)))
        } else if (n === 'Not In') {
          const selectedIds = new Set(selectedProviderFacilities.map(f => String(f.FacilityID)))
          newFacilities = allFacilities.current.filter(facility => !selectedIds.has(String(facility.ID)))
        } else {
          newFacilities = allFacilities.current.filter(obj => obj.Status === n)
        }
      } else {
        if (userTriggered) {
          toast.error('Please select a provider.', toastConfig)
        }
        return
      }
    } else if (type === 'county') {
      newFacilities = allFacilities.current.filter(obj => obj.County === n)
    }

    setFacilities(newFacilities)
  };

  const applyProviderFilter = (provider, overrideTypeName = typeName) => {
    if (!provider) {
      onFilter('type', 'all')
      return
    }

    const facilityTypeName = overrideTypeName || ''
    onFilter('type', 'radius', provider.ID, facilityTypeName)
  }

  useEffect(() => {
    if (selectedProvider.length > 0) {
      applyProviderFilter(selectedProvider[0], typeName)
    }
  }, [selectedProvider, typeName, radius, isToggled, selectedProviderFacilities])

  const markerClick = (name) => {
    let facility = facilities.find(obj => obj.Name === name);

      if (!facility) return;
      
    let type = facility["Type"];
    let details = facility["Details"];

    let questions = facilityType.find(obj => obj.Name === type);
    if (details === "" || details === null || details === undefined) {
      details = null;
    } else {
      setFormAnswer(JSON.parse(details));
    }
    let schema = JSON.parse(questions.Details);
    setSchema(schema);
    setVisible(true);
  };

  const submitFn = async () => {
    await fetchFacility();
    setModalVisible(false);
    setSearchValue('');
  };

  const handleAddFacility = async (obj) => {
    // Geocode the address to get the latitude and longitude coordinates
    const geocoder = new window.google.maps.Geocoder();
    let addr = obj.Address;
    let facility = await geocoder.geocode({ address: addr }, (results, status) => {
      if (status === 'OK') {
        const latLng = results[0].geometry.location;
        let name = obj.Name;
        let address = obj.Address;
        let type = obj.Type;
        try {
          newFacility.current = [...newFacility.current, { name, address, type, latLng }];
        } catch (e) {
          // Handle error
        }
      } else {
        alert(`Geocode was not successful for the following reason: ${status}`);
      }
    });
  };


  const handleProviderFacility = (event) => {

    const facilityID = event.target.value;
    setProviderSelectedFacility(prevSelected =>
      event.target.checked
        ? [...prevSelected, facilityID]
        : prevSelected.filter(id => id !== facilityID)
    );
  }


  const handleProviderChange = (e) => {
    let providerDetails = e.target ? e.target.value : e.value;
    if (providerDetails === '') {
      setSelectedProviderID(-1);
      setSelectedProviderName('');
      setSelectedProvider([]);
      onFilter('type', 'all');
      handleFacilityChange({ value: selectedFacility.value, label: selectedFacility.label })
    } else {
      const selectedProviderItem = providerList.find(provider => provider.ID === parseInt(e.target ? e.target.value : e.value));
      setSelectedProviderID(selectedProviderItem ? selectedProviderItem.ID : -1);
      setSelectedProviderName(selectedProviderItem ? selectedProviderItem.Name : '');
      setSelectedProvider([selectedProviderItem]);
      if (selectedProviderItem) {
        applyProviderFilter(selectedProviderItem, typeName)
      }
    }
  };

  const GetSelectedProviderFacility = async (provider, providerInfo) => {

    let providerData
    providerData = await fetchPatientData("SELECTALL", "Provider", JSON.stringify({ ID: provider }));
    providerData = JSON.parse(providerData?.d)
    if (providerData) {
      const providerFacilities = providerData?.Facility
      const providerInsurance = providerData?.Insurance
      setSelectedProviderFacilities(providerFacilities)
      const facilityIDs = providerFacilities.map(item => item.FacilityID);
      const finalFacilities = facilities.filter(facility => facilityIDs.includes(facility.ID.toString()));
      let providerDetails = {
        "Details": providerInfo[0],
        "Insurances": providerInsurance,
        "facilities": providerFacilities
      }
      setProviderFullDetails(providerDetails)
    }


  }

  useEffect(() => {
    if (selectedProvider?.length > 0 && selectedProviderID > 0) {
      GetSelectedProviderFacility(selectedProviderID, selectedProvider)
    }
  }, [selectedProviderID, selectedProviderName, selectedProvider])

  const handleCountyChange = (e) => {
    const county = e.value;
    setSelectedCounty(county);
    if (county === '') {
      setFacilities(allFacilities.current);
    } else {
      onFilter("county", county);
    }
  };
  const handleFacilityChange = (e) => {
    setSelectedFacilities(e)
    const facility = e.value;
    if (facility === "") {
      setFacilities(allFacilities.current);
      onFilter("type", "Mixed");
    } else {
      if (selectedProvider.length > 0) {
        onFilter("type", 'radius', selectedProvider[0].ID, facility === 'all' ? '' : facility)
      } else {
        onFilter("type", facility);
      }

    }
  }

  const handlePracticingChange = (e) => {
    setPracticing(e)
    const practices = e.value
    if (practices === 'all') {
      onFilter("type", practices);
    } else {
      setFacilities(allFacilities.current);
      onFilter("type", "Mixed");
    }
  }

  const providerOptions = [
    { value: "", label: "Select Provider" },
    ...providerList.map(provider => ({
      value: provider.ID,
      label: provider.Name
    }))
  ];
  const countryOption = [{ value: "", label: "Select County" }, ...countyList.map(country => ({ value: country, label: country }))]
  const FacilityOption = [
    { value: "", label: "Select facility" },
    { value: 'all', label: 'ALL' },
    ...facilityType.map(facility => ({ value: facility.Name, label: facility.Name }))
  ]

  const handleSubmit = async () => {

    let Details = providerFullDetails?.Details;
    let Insurances = providerFullDetails?.Insurances;
    let newAddedFacility = providerSelectedFacility.map((providerID) => {
      let newFacility = facilities.filter((facility) => facility.ID === parseInt(providerID))[0]
      return newFacility;
    })

    let newFacilityList = newAddedFacility?.map((item) => {
      return {
        FacilityID: item.ID.toString(),
        Days: item.Days,
        Credentialed: 'No'
      }
    })

    let oldFacilityList = providerFullDetails?.facilities.map((item) => {
      return {
        FacilityID: item.FacilityID,
        Days: item.Days,
        Credentialed: item.Credentialed,
      }
    })

    let FinalFacilityList = [...oldFacilityList, ...newFacilityList]
    const providerData = {
      Name: Details.Name,
      Gender: Details.Gender,
      DOB: Details.DOB,
      Address: Details.Address,
      contractStartDate: Details?.contractStartDate,
      AddressDetails: Details.AddressDetails,
      Lat: Details.Lat,
      Lng: Details.Lng,
      Insurances: JSON.stringify(Insurances),
      Facilities: JSON.stringify(FinalFacilityList)
    };

    try {
      await fetchPatientData("UPDATE", "Provider", JSON.stringify({ ...providerData, ID: Details.ID }));
      toast.success('Successfully Added', toastConfig)
      if (selectedProvider) {
        GetSelectedProviderFacility(selectedProviderID, selectedProvider)
      }
      handleFacilityChange({ value: 'all', label: 'ALL' })
      // setIsDropdownVisible(true)
      // handleFacilityChange({ value: selectedFacility.value, label: selectedFacility.label })
    } catch (error) {
      console.error("Submit error:", error);
    }
    setProviderSelectedFacility([])

  }
const getFacilityList = () => {
  if (!selectedProvider?.length) return facilities

  const targetLat = parseFloat(selectedProvider[0]?.Lat)
  const targetLng = parseFloat(selectedProvider[0]?.Lng)

  return facilities.filter((facility) => {
    const facilityLat = parseFloat(facility.Lat)
    const facilityLng = parseFloat(facility.Lng)

    const distance = haversineDistance(
      targetLat,
      targetLng,
      facilityLat,
      facilityLng
    )

    return distance <= Math.round(radius * 1609.34) / 1000
  })
}
  const practicingOption = [{ value: "", label: "Select Practice" }, { value: "all", label: "Cerebrum Health Care" }]
  useEffect(() => {
    const getData = async () => {
      await fetchFacility();
       
    };
    getData();
    
  }, []);

  useEffect(() => {
    const providerToUse = selectedProviderProp || selectedProviderData;

    const providerNameFromState = providerToUse?.Name || providerToUse?.Details?.Name || '';
    const providerName = providerNameFromState || queryProviderName;

    if (!providerName && !providerToUse) return;

    let providerMatch = null;

    if (providerToUse?.ID || providerToUse?.Details?.ID) {
      const providerId = providerToUse?.ID || providerToUse?.Details?.ID;
      providerMatch = providerList.find((provider) => provider.ID === providerId) || providerToUse;
    } else if (providerName) {
      providerMatch = providerList.find((provider) => provider.Name === providerName) || null;
    }

    if (!providerMatch) return;

    setSelectedProviderID(providerMatch.ID || providerMatch?.Details?.ID || -1);
    setSelectedProviderName(providerMatch.Name || providerName || '');
    setSelectedProvider([providerMatch]);

    if (Array.isArray(providerToUse?.Facilities)) {
      setSelectedProviderFacilities(providerToUse.Facilities);
    } else if (providerMatch?.ID) {
      // fetch provider facilities if not provided
      GetSelectedProviderFacility(providerMatch.ID, [providerMatch])
    }

    if (providerMatch.ID) {
      applyProviderFilter(providerMatch, typeName)
    }
  }, [selectedProviderProp, selectedProviderData, providerList, queryProviderName])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

 


  return (
    <>
      <CRow className='mb-2'>
        <CCol sm={3}>
          <AutoComplete initialValue={searchValue} AddFacilityFn={AddFacilityFn}></AutoComplete>
        </CCol>
        <CCol sm={2}>
          <div style={{ display: 'flex', alignItems: 'baseline' }}>
            <CFormLabel style={{ flex: 1, marginRight: '8px' }}>Radius</CFormLabel>
             <CFormInput 
               className='w-50' 
               value={radius} 
               onChange={(e) => { setRadius(e.target.value) }}
               style={{
                 backgroundColor: 'var(--ui-dashboard-surface-2, #1b1b1b)',
                 color: 'var(--ui-text-primary, #ffffff)',
                 borderColor: 'var(--ui-dashboard-border-strong, #ced4da)',
                 textAlign: 'center'
               }}
             ></CFormInput>
            <CFormLabel className='pt-1 ps-2' style={{ flex: 1 }}>Miles</CFormLabel>
          </div>
        </CCol>
         <CCol sm={5} className="d-flex justify-content-end">
                  <div ref={dropdownRef} style={{ position: 'absolute', display: 'inline-block' }}>
                 <CButton
          onClick={toggleDropdown}
          color=""
          variant="outline"
          className={`d-flex justify-content-between align-items-center no-hover ${
            selectedProvider.length <= 0 ? "disabled" : ""
          }`}
          style={{
            width: "250px",
            height: "38px",
            background: "var(--ui-dashboard-surface-2, #1b1b1b)",
            border: "1px solid var(--ui-dashboard-border-strong, #ced4da)",
            borderRadius: "6px",
            margin: "0 10px",
            cursor: selectedProvider.length <= 0 ? "not-allowed" : "pointer",
            pointerEvents: selectedProvider.length <= 0 ? "none" : "auto",
            fontWeight: 500,
            color: "var(--ui-text-primary)",
          }}
        >
          <span>Facilities within Radius</span>
        
          <span
            style={{
              transition: "transform .2s ease",
              transform: isDropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
              fontSize: "12px",
            }}
          >
            ▼
          </span>
        </CButton>

             {isDropdownOpen && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  right: 5,
                  width: '500px',
                  backgroundColor: 'var(--ui-dashboard-surface-2, #1b1b1b)',
                  border: '1px solid var(--ui-dashboard-border-strong, #3a3a3a)',
                  color: 'var(--ui-text-primary)',
                  boxShadow: '0px 4px 8px rgba(0,0,0,0.3)',
                  zIndex: 1000,
                  borderRadius: '7px'
                }}
              >
             <div className="container p-2">
   
  <div className="d-flex justify-content-end align-items-center gap-2  p-2">
 
  
  <input
    type="text"
    className="form-control"
    placeholder="Search Facilities"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    style={{
       backgroundColor: 'var(--ui-dashboard-surface, #161616)',
       color: 'var(--ui-text-primary, #ffffff)',
       borderColor: 'var(--ui-dashboard-border-strong, #3a3a3a)'
     }}
  />

  <CButton
    color="primary"
    variant="outline"
    size="sm"
    onClick={() => {
      const facilityList = validateFacilityList();

      if (!facilityList) return;

      const text = facilityList
        .map(f => `${f.Name}`)
        .join('\n');

      navigator.clipboard.writeText(text);
      toast.success('Copied to clipboard', toastConfig);
    }}
  >
    <Copy size={15} className="me" />
   
  </CButton>

  <CButton
    color="success"
    variant="outline"
    size="sm"
    onClick={() => {
      handleDownload();
      setIsDropdownOpen(false);
    }}
  >
    <Download size={15} className="me" />
  
  </CButton>
</div>
    <ul
     className="list-unstyled p-2 rounded"
     style={{ overflow: 'auto', height: '300px', backgroundColor: 'var(--ui-dashboard-surface, #161616)' }}
   >
  <ul className="list-unstyled rounded" style={{ backgroundColor: 'transparent' }}>
  
 {getFacilityList()
  .filter((facility) =>
    facility.Name.toLowerCase().includes(searchTerm.toLowerCase())
  )
  .map((facility) => {
     const providerRecord = selectedProviderFacilities.find(
      (p) => String(p.FacilityID) === String(facility.ID)
    )
console.log('Facility:', facility.Name, 'Provider Record:', providerRecord)
let status = 'Not In';

      if (providerRecord) {
        if (providerRecord.Credentialed === 'Yes') {
          status = 'Credentialed';
        } else if (
          providerRecord.Credentialed === 'In Progress' ||
          providerRecord.Credentialed === 'Credentialing (In Progress)'
        ) {
          status = 'Credentialing (In Progress)';
        } else {
          status = providerRecord.Credentialed;
        }
      }

   // const isChecked = status !== 'Not In'
const isDisabled =
  providerRecord?.Credentialed === 'Yes' ||
  providerRecord?.Credentialed === 'In Progress';
const isChecked = providerSelectedFacility.includes(
  String(facility.ID)
)
const getStatusColor = (status) => {
  switch (status) {
    case "Credentialed":
      return "green";

    case "Credentialing (In Progress)":
    case "In Progress":
      return "yellow";

    case "Not In":
      return "red";

    default:
       return "red";
  }

};
    return (
      <li
        key={facility.ID}
        className="mb-2 p-2 rounded d-flex justify-content-between  align-items-center"
        style={{
          backgroundColor: 'var(--ui-dashboard-surface-2, #1b1b1b)',
          color: 'var(--ui-text-primary, #ffffff)'
        }}
      >
 
        <label className="d-flex align-items-center gap-2 m-0" style={{ color: 'var(--ui-text-primary, #ffffff)' }}>
          <input
            type="checkbox"
            value={facility.ID}
            checked={isChecked}
           disabled={isDisabled}
            onChange={handleProviderFacility}
          />
          {facility.Name}
        </label>

   <span
  title={status}
  style={{
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    backgroundColor: getStatusColor(status),
    display: "inline-block",
  }}
></span>
      </li>
    )
  })}
</ul>
  </ul>
  
  <div className="d-flex justify-content-end align-items-center gap-2  p-2">  
    <button
      className="btn btn-sm btn-outline-secondary"
      onClick={() => setIsDropdownOpen(false)}
    >
      Close
    </button>

    <button
       className="btn btn-sm btn-primary"
       onClick={handleSubmitAndClose}
       style={{ color: '#ffffff' }}
     >
  Start Credentialing
     </button>
  </div>
</div>
              </div>
            )}
          </div>
        </CCol>


        <CCol sm={1} className="  d-flex justify-content-end "   >
          <CDropdown  >
            <CDropdownToggle color="" className="no-hover  " style={{ width: '100px', background: 'var(--ui-dashboard-surface)', border: '1px solid var(--ui-dashboard-border-strong)', color: 'var(--ui-text-primary)', margin: '0 10px 0 10px' }}>Filter <span className='p-2'> <Filter size={16} /></span></CDropdownToggle>
            <CDropdownMenu className='' style={{ width: '300px', top: '45px', right: '0', backgroundColor: 'var(--ui-dashboard-surface-2, #1b1b1b)', border: '1px solid var(--ui-dashboard-border-strong, #3a3a3a)' }}>
              <CDropdownItem href="#" className="no-hover" style={{ backgroundColor: 'transparent' }}>  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                <CFormLabel style={{ flex: 1, marginRight: '8px', color: 'var(--ui-text-primary, #ffffff)' }}>Practice</CFormLabel>
                <Select
                  options={practicingOption}
                  onChange={handlePracticingChange}
                  value={practicing}
                  className="w-100"
                  closeMenuOnSelect={false}
                  styles={selectDarkThemeStyles}
                />
              </div>
              </CDropdownItem>
              <CDropdownItem className=" no-hover" style={{ backgroundColor: 'transparent' }} >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                  <CFormLabel style={{ flex: 1, marginRight: '8px', color: 'var(--ui-text-primary, #ffffff)' }}>Provider</CFormLabel>
                  <Select
                    options={providerOptions}
                    onChange={handleProviderChange}
                    value={providerOptions.find(option => option.value === selectedProviderID)}
                    className="w-100"
                    closeMenuOnSelect={false}
                    styles={selectDarkThemeStyles}
                  />
                </div>

              </CDropdownItem  >
              <CDropdownItem className=" no-hover" style={{ backgroundColor: 'transparent' }} >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                  <CFormLabel style={{ flex: 1, marginRight: '8px', color: 'var(--ui-text-primary, #ffffff)' }}>All Credentialed Facilities</CFormLabel>
                  <div className="form-check form-switch  ms-2"  >
                    <input
                      className={`form-check-input ${!isToggled ? 'bg-success border-success' : ''}`}
                      type="checkbox"
                      role="switch"
                      id="toggleSwitch"
                      checked={!isToggled}
                      onChange={handleToggle}
                      disabled={selectedProvider.length > 0 ? false : true}
                    />
                    <label className="form-check-label" htmlFor="toggleSwitch" style={{ color: 'var(--ui-text-primary, #ffffff)' }}>
                      {isToggled ? 'Hide' : 'Show'}
                    </label>
                  </div>
                </div>

              </CDropdownItem  >
              <CDropdownItem className="no-hover" style={{ backgroundColor: 'transparent' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                  <CFormLabel style={{ flex: 1, marginRight: '8px', color: 'var(--ui-text-primary, #ffffff)' }}>County</CFormLabel>
                  <Select
                    options={countryOption}
                    onChange={handleCountyChange}
                    value={countryOption.find(option => option.value === selectedCounty)}
                    className="w-100"
                    closeMenuOnSelect={false}
                    styles={selectDarkThemeStyles}
                  />
                </div>
              </CDropdownItem>
              <CDropdownItem href="#" className="no-hover" style={{ backgroundColor: 'transparent' }}>  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                <CFormLabel style={{ flex: 1, marginRight: '8px', color: 'var(--ui-text-primary, #ffffff)' }}>Facility Type</CFormLabel>
                <Select
                  options={FacilityOption}
                  onChange={handleFacilityChange}
                  value={selectedFacility}
                  className="w-100"
                  closeMenuOnSelect={false}
                  styles={selectDarkThemeStyles}
                />
              </div>
              </CDropdownItem>

            </CDropdownMenu>
          </CDropdown>
        </CCol>

      </CRow>

      <div>
        <SchedulerFacilityMap selectedProviderFacilities={selectedProviderFacilities} Radius={radius} onFilter={onFilter} providerList={selectedProvider} facilities={facilities} types={facilityType} MarkerClick={markerClick} setFacilities={setFacilities} isDropdownVisible={isDropdownVisible} scheduleAppointmentPatinet={scheduleAppointmentPatinet} scheduledPatient={scheduledPatient} selectedProviderDataRed={selectedProviderData}></SchedulerFacilityMap>
      </div>

      <CModal size="md" visible={modalVisible} backdrop={'static'} keyboard={false} onClose={() => setModalVisible(false)}>
        <CModalHeader onClose={() => setModalVisible(false)}>
          <CModalTitle>Add Facility</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <FacilityForm Lat={rowData.current.Lat} Lng={rowData.current.Lng} initialAddress={rowData.current.Address} Mode={'INSERT'} typeOptions={options} initialName={rowData.current.Name} Status={'Pending'} onSubmit={submitFn} ></FacilityForm>
        </CModalBody>
      </CModal>

      <CModal size="lg" backdrop={'static'} keyboard={false} visible={visible} onClose={() => setVisible(false)}>
        <CModalHeader onClose={() => setVisible(false)}>
          <CModalTitle>Facility Details</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Form form={schema} submission={formAnswer} />
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  );
};

export default AddFacility;
